"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.remoteUserStoppedTyping = exports.remoteUserTyping = exports.currentUserStoppedTyping = exports.currentUserTyping = exports.REMOTE_USER_STOPPED_TYPING = exports.REMOTE_USER_TYPING = exports.CURRENT_USER_STOPPED_TYPING = exports.CURRENT_USER_TYPING = void 0;
exports.CURRENT_USER_TYPING = "CURRENT_USER_TYPING";
exports.CURRENT_USER_STOPPED_TYPING = "CURRENT_USER_STOPPED_TYPING";
exports.REMOTE_USER_TYPING = "REMOTE_USER_TYPING";
exports.REMOTE_USER_STOPPED_TYPING = "REMOTE_USER_STOPPED_TYPING";
function currentUserTyping(chatId) {
    return {
        type: exports.CURRENT_USER_TYPING,
        payload: chatId
    };
}
exports.currentUserTyping = currentUserTyping;
function currentUserStoppedTyping(chatId) {
    return {
        type: exports.CURRENT_USER_STOPPED_TYPING,
        payload: chatId
    };
}
exports.currentUserStoppedTyping = currentUserStoppedTyping;
function remoteUserTyping(chatId, userId) {
    return {
        type: exports.REMOTE_USER_TYPING,
        payload: {
            chatId,
            userId
        }
    };
}
exports.remoteUserTyping = remoteUserTyping;
function remoteUserStoppedTyping(chatId, userId) {
    return {
        type: exports.REMOTE_USER_STOPPED_TYPING,
        payload: {
            chatId,
            userId
        }
    };
}
exports.remoteUserStoppedTyping = remoteUserStoppedTyping;
